var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clinics-map-container"},[_c('div',{staticClass:"map-container",staticStyle:{"width":"100%","height":"800px"},attrs:{"id":_vm.mapContainerId}}),_c('v-overlay',{attrs:{"value":_vm.loading,"z-index":"9999"}},[_c('div',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.loadingMessage))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }